import { gql } from '@/__generated__';

const GET_UNREAD_NOTIFICATIONS_COUNT = gql(`#graphql
  query GetUnreadNotificationsCount {
    notificationsConnection(filter: { statuses: [NEW, UNREAD] }) {
      pageInfo {
        totalCount
      }
    }
  }
`);

export default GET_UNREAD_NOTIFICATIONS_COUNT;
